"use strict";
/* eslint-disable import/extensions */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var BotActions_1 = require("@src/actions/BotActions");
var _utils_1 = require("@src/actions/_utils");
var const_1 = require("@src/const");
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var CodeEditor_1 = __importDefault(require("@src/components/CodeEditor"));
var CommonStore_1 = __importDefault(require("@src/stores/CommonStore"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var dropdown_1 = __importDefault(require("relements/build/esm/input/dropdown"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var checkbox_1 = __importDefault(require("relements/build/esm/input/checkbox"));
var toggle_1 = __importDefault(require("relements/build/esm/input/toggle"));
var BinIcon_1 = __importDefault(require("relements/build/esm/ui/icons/BinIcon"));
var const_2 = require("@src/containers/CodeNode/utils/const");
var actions_1 = require("../../CodeNode/store/actions");
var api_1 = require("../store/api");
var utils_1 = require("../utils");
var selectors_1 = require("../store/selectors");
var actions_2 = require("../store/actions");
// eslint-disable-next-line import/extensions
var StyledComponets_1 = require("./StyledComponets");
// eslint-disable-next-line import/extensions
var Label_1 = __importDefault(require("./Label"));
var VoiceAgentLayoutUtils_1 = require("./VoiceAgentLayoutUtils");
var VoiceAgentToolItem = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var toolData = _a.toolData, number = _a.number, nextAgentOptions = _a.nextAgentOptions, onToolChange = _a.onToolChange, onDeleteTool = _a.onDeleteTool, headerActions = _a.headerActions, _j = _a.readOnly, readOnly = _j === void 0 ? false : _j, _k = _a.hasUnsavedChanges, hasUnsavedChanges = _k === void 0 ? false : _k, onOuterSave = _a.onOuterSave, onDiscardChanges = _a.onDiscardChanges, openCodeEditorProp = _a.openCodeEditor, onOpenCodeEditorChange = _a.onOpenCodeEditorChange, validateDelete = _a.validateDelete;
    var envVariables = react_redux_1.useSelector(selectors_1.getEnvVariables);
    var domainId = react_redux_1.useSelector(selectors_1.getDomainId);
    var botSettings = react_redux_1.useSelector(selectors_1.getDomainData);
    var dispatch = react_redux_1.useDispatch();
    var languages = CommonStore_1["default"].getMetaTags().allLanguages;
    var languagesList = languages.filter(function (lang) { var _a; return (_a = botSettings === null || botSettings === void 0 ? void 0 : botSettings['supported_languages']) === null || _a === void 0 ? void 0 : _a.includes(lang.code); });
    var _l = react_1["default"].useState(false), localOpenCodeEditor = _l[0], setLocalOpenCodeEditor = _l[1];
    var openCodeEditor = openCodeEditorProp !== undefined ? openCodeEditorProp : localOpenCodeEditor;
    var setOpenCodeEditor = react_1["default"].useCallback(function (open) {
        setLocalOpenCodeEditor(open);
        if (onOpenCodeEditorChange) {
            onOpenCodeEditorChange(open);
        }
    }, [onOpenCodeEditorChange]);
    var _m = react_1["default"].useState([]), parameterRows = _m[0], setParameterRows = _m[1];
    var _o = react_1["default"].useState(null), selectedRagLanguage = _o[0], setSelectedRagLanguage = _o[1];
    var initializedRagToolKeyRef = react_1["default"].useRef('');
    var selectedToolBehavior = (toolData === null || toolData === void 0 ? void 0 : toolData.mode) === 'tool_call'
        ? VoiceAgentLayoutUtils_1.toolBehaviorOptions.find(function (option) {
            return option.mode === 'tool_call' &&
                option.codeType === VoiceAgentLayoutUtils_1.getToolCallCodeType(toolData);
        }) || VoiceAgentLayoutUtils_1.toolBehaviorOptions[1]
        : VoiceAgentLayoutUtils_1.toolBehaviorOptions.find(function (option) { return option.id === (toolData === null || toolData === void 0 ? void 0 : toolData.mode); }) ||
            {};
    var isNewTool = Boolean(toolData === null || toolData === void 0 ? void 0 : toolData.isNew);
    var normalizeComparable = function (value) {
        return (value || '').toString().trim().toLowerCase();
    };
    var selectedNextAgent = nextAgentOptions.find(function (option) {
        return normalizeComparable(option.name) ===
            normalizeComparable(toolData === null || toolData === void 0 ? void 0 : toolData.nextAgent) ||
            normalizeComparable(option.id) ===
                normalizeComparable(toolData === null || toolData === void 0 ? void 0 : toolData.nextAgent);
    }) || {};
    var languageSpecificPrompt = (toolData === null || toolData === void 0 ? void 0 : toolData.languageSpecificPrompt) || {};
    var configuredLanguageCount = Object.values(languageSpecificPrompt).filter(function (value) { return (value || '').toString().trim().length > 0; }).length;
    var getDefaultRagLanguage = function () {
        var promptLanguage = languagesList.find(function (lang) {
            var languageKey = (lang === null || lang === void 0 ? void 0 : lang.code) || (lang === null || lang === void 0 ? void 0 : lang.id);
            return (languageKey &&
                ((languageSpecificPrompt === null || languageSpecificPrompt === void 0 ? void 0 : languageSpecificPrompt[languageKey]) || '').toString().trim().length >
                    0);
        });
        return promptLanguage || languagesList[0] || null;
    };
    var activeRagLanguage = selectedRagLanguage ||
        ((toolData === null || toolData === void 0 ? void 0 : toolData.mode) === 'rag' ? getDefaultRagLanguage() : null);
    var TextInputComponent = readOnly
        ? StyledComponets_1.StyledTextInputDisabled
        : StyledComponets_1.StyledTextInput;
    react_1["default"].useEffect(function () {
        var mappedRows = VoiceAgentLayoutUtils_1.mapParametersToRows(toolData === null || toolData === void 0 ? void 0 : toolData.parameters);
        setParameterRows(function (prevRows) {
            return mappedRows.map(function (row, index) {
                var _a;
                return (__assign(__assign({}, row), { rowId: ((_a = prevRows === null || prevRows === void 0 ? void 0 : prevRows[index]) === null || _a === void 0 ? void 0 : _a.rowId) ||
                        row.rowId ||
                        "param-" + ((toolData === null || toolData === void 0 ? void 0 : toolData.id) || number) + "-" + index }));
            });
        });
    }, [toolData === null || toolData === void 0 ? void 0 : toolData.id, toolData === null || toolData === void 0 ? void 0 : toolData.mode]);
    react_1["default"].useEffect(function () {
        var _a;
        if ((toolData === null || toolData === void 0 ? void 0 : toolData.mode) !== 'rag') {
            initializedRagToolKeyRef.current = '';
            return;
        }
        if (!languagesList.length) {
            setSelectedRagLanguage(null);
            return;
        }
        var toolKey = String((_a = toolData === null || toolData === void 0 ? void 0 : toolData.id) !== null && _a !== void 0 ? _a : 'new');
        var selectedLanguageCode = (selectedRagLanguage === null || selectedRagLanguage === void 0 ? void 0 : selectedRagLanguage.code) || (selectedRagLanguage === null || selectedRagLanguage === void 0 ? void 0 : selectedRagLanguage.id);
        var selectedExists = selectedLanguageCode
            ? languagesList.some(function (lang) {
                return lang.code === selectedLanguageCode ||
                    lang.id === selectedLanguageCode;
            })
            : false;
        var shouldInitialize = initializedRagToolKeyRef.current !== toolKey || !selectedExists;
        if (shouldInitialize) {
            setSelectedRagLanguage(getDefaultRagLanguage());
            initializedRagToolKeyRef.current = toolKey;
        }
    }, [
        toolData === null || toolData === void 0 ? void 0 : toolData.mode,
        toolData === null || toolData === void 0 ? void 0 : toolData.id,
        languagesList,
        languageSpecificPrompt,
        selectedRagLanguage,
    ]);
    var syncParameterRows = function (nextRows) {
        setParameterRows(nextRows);
        onToolChange('parameters', VoiceAgentLayoutUtils_1.mapRowsToParameters(nextRows));
    };
    var navToCodeSubMenu = function (edited) {
        if (edited) {
            BotActions_1.showConfirmationDialog({
                okTitle: 'Leave',
                cancelTitle: 'Keep Editing',
                title: 'Are you sure you want to leave?',
                message: "It looks like you're still working on this. You may lose the info you've entered so far if you leave now.",
                onOk: function () {
                    setOpenCodeEditor(false);
                },
                onCancel: function () { },
                okActionType: 'danger',
            });
        }
        else {
            setOpenCodeEditor(false);
        }
    };
    var toolDataRef = react_1["default"].useRef(toolData);
    var onOuterSaveRef = react_1["default"].useRef(onOuterSave);
    var onToolChangeRef = react_1["default"].useRef(onToolChange);
    react_1["default"].useEffect(function () {
        toolDataRef.current = toolData;
        onOuterSaveRef.current = onOuterSave;
        onToolChangeRef.current = onToolChange;
    }, [toolData, onOuterSave, onToolChange]);
    var handleSave = function (code, cb) { return __awaiter(void 0, void 0, void 0, function () {
        var tData, toolCodeType, shouldCreateLambda, payload, response, responseBody, lambdaFunctionName, error_1;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    tData = toolDataRef.current;
                    toolCodeType = VoiceAgentLayoutUtils_1.getToolCallCodeType(tData);
                    shouldCreateLambda = (tData === null || tData === void 0 ? void 0 : tData.mode) === 'tool_call' && toolCodeType !== 'quick';
                    onToolChangeRef.current('code', code);
                    if (!!shouldCreateLambda) return [3 /*break*/, 3];
                    if (!onOuterSaveRef.current) return [3 /*break*/, 2];
                    return [4 /*yield*/, onOuterSaveRef.current(code)];
                case 1:
                    _e.sent();
                    _e.label = 2;
                case 2:
                    cb(true);
                    BotActions_1.createAlert('Code saved !', null, MogamboConstants_1.AlertTypes.POSITIVE);
                    return [2 /*return*/];
                case 3:
                    _e.trys.push([3, 7, , 8]);
                    payload = {
                        custom_code_block: code,
                    };
                    if (((tData === null || tData === void 0 ? void 0 : tData.lambdaFunctionName) || '').toString().trim()) {
                        payload.function_name = tData.lambdaFunctionName;
                    }
                    return [4 /*yield*/, api_1.createCodeExecutorFunction(payload)];
                case 4:
                    response = _e.sent();
                    if (!(response === null || response === void 0 ? void 0 : response.success)) {
                        throw new Error(((_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.error) ||
                            // response?.response?.message ||
                            'Failed to save code.');
                    }
                    responseBody = VoiceAgentLayoutUtils_1.getResponseBody(response === null || response === void 0 ? void 0 : response.response);
                    lambdaFunctionName = (_d = (_c = (_b = responseBody === null || responseBody === void 0 ? void 0 : responseBody['lambda_function_name']) !== null && _b !== void 0 ? _b : responseBody === null || responseBody === void 0 ? void 0 : responseBody['function_name']) !== null && _c !== void 0 ? _c : tData === null || tData === void 0 ? void 0 : tData.lambdaFunctionName) !== null && _d !== void 0 ? _d : '';
                    if (lambdaFunctionName) {
                        onToolChangeRef.current('lambdaFunctionName', lambdaFunctionName);
                    }
                    if (!onOuterSaveRef.current) return [3 /*break*/, 6];
                    return [4 /*yield*/, onOuterSaveRef.current(code, lambdaFunctionName)];
                case 5:
                    _e.sent();
                    _e.label = 6;
                case 6:
                    cb(true);
                    BotActions_1.createAlert('Code saved !', null, MogamboConstants_1.AlertTypes.POSITIVE);
                    return [3 /*break*/, 8];
                case 7:
                    error_1 = _e.sent();
                    BotActions_1.createAlert((error_1 === null || error_1 === void 0 ? void 0 : error_1.message) || error_1 || 'Error occurred while saving code.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                    cb(false);
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var handleRun = function (inputJson, cb) {
        actions_1.runCodeNodeData('', inputJson, function (success, e) {
            if (e && cb) {
                cb(e);
            }
            if (success) {
                BotActions_1.createAlert('Code run completed!', null, MogamboConstants_1.AlertTypes.POSITIVE);
            }
            else {
                BotActions_1.createAlert('Code run failed!', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            }
        });
    };
    var onSaveWithVariables = function (variables, code, cb) {
        if (cb === void 0) { cb = function (a) { }; }
        if (!_utils_1.userHasPermission(const_1.PERMISSION_LEVELS.MOGAMBO_ALL_EDIT)) {
            cb(false);
            _utils_1.permissionErrorAlert();
            return;
        }
        if (!_utils_1.userHasPermission(const_1.PERMISSION_LEVELS.EDIT_ENV_VARIABLES)) {
            BotActions_1.createAlert('Not Valid Permissions', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            cb(false);
        }
        dispatch(actions_2.setEnvVariables(variables));
        onToolChange('code', code);
        Promise.all([utils_1.saveEnvVariablesForActions(domainId, variables)])
            .then(function () {
            BotActions_1.createAlert('Successfully Saved!', null, MogamboConstants_1.AlertTypes.POSITIVE);
            cb(true);
        })["catch"](function (err) {
            BotActions_1.createAlert(err, null, MogamboConstants_1.AlertTypes.NEGATIVE);
            cb(false);
        });
    };
    return (react_1["default"].createElement(box_1["default"], { padding: "16px", flexDirection: "column", backgroundColor: "#fff", mb: "16px", style: {
            gap: '12px',
            borderRadius: '8px',
            border: '1px solid #efefef',
        } },
        react_1["default"].createElement(box_1["default"], { padding: "0", justifyContent: "space-between", alignItems: "center", style: { marginBottom: '4px' } },
            react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" },
                "Tool ",
                number),
            headerActions || (react_1["default"].createElement(box_1["default"], { padding: "0", style: { cursor: 'pointer' }, onClick: function () {
                    if (!onDeleteTool)
                        return;
                    if (validateDelete) {
                        var errorMsg = validateDelete();
                        if (errorMsg) {
                            BotActions_1.createAlert(errorMsg, null, MogamboConstants_1.AlertTypes.NEGATIVE);
                            return;
                        }
                    }
                    BotActions_1.showConfirmationDialog({
                        okTitle: 'Delete',
                        cancelTitle: 'Cancel',
                        title: 'Delete this tool?',
                        message: 'This action cannot be undone.',
                        okActionType: 'danger',
                        onCancel: function () { },
                        onOk: function () {
                            onDeleteTool();
                        },
                    });
                }, title: "Delete tool" },
                react_1["default"].createElement(BinIcon_1["default"], { size: "small", iconColor: "red.haptik" })))),
        react_1["default"].createElement(dropdown_1["default"], { placeholder: "Select tool behavior", themed: true, options: VoiceAgentLayoutUtils_1.toolBehaviorOptions, value: selectedToolBehavior, optionKey: "name", disabled: readOnly || !isNewTool, onChange: function (val) {
                var _a, _b, _c, _d, _e;
                if (readOnly)
                    return;
                if (!isNewTool)
                    return;
                var selectedMode = (val === null || val === void 0 ? void 0 : val.mode) || (val === null || val === void 0 ? void 0 : val.id);
                onToolChange('mode', selectedMode);
                if (selectedMode === 'tool_call') {
                    onToolChange('parameters', VoiceAgentLayoutUtils_1.normalizeToolParameters(toolData === null || toolData === void 0 ? void 0 : toolData.parameters));
                    onToolChange('codeType', (val === null || val === void 0 ? void 0 : val.codeType) || 'advanced');
                    onToolChange('lambdaFunctionName', '');
                    onToolChange('code', (val === null || val === void 0 ? void 0 : val.codeType) === 'quick'
                        ? VoiceAgentLayoutUtils_1.QUICK_CODE_MULTI_VOICE_AGENT
                        : const_2.INIT_CODE_MULTI_VOICE_AGENT);
                }
                if (selectedMode === 'rag') {
                    onToolChange('appId', (_b = (_a = toolData === null || toolData === void 0 ? void 0 : toolData.appId) !== null && _a !== void 0 ? _a : toolData === null || toolData === void 0 ? void 0 : toolData['app_id']) !== null && _b !== void 0 ? _b : '');
                    onToolChange('prompt', (_c = toolData === null || toolData === void 0 ? void 0 : toolData.prompt) !== null && _c !== void 0 ? _c : '');
                    onToolChange('languageSpecificPrompt', (_e = (_d = toolData === null || toolData === void 0 ? void 0 : toolData.languageSpecificPrompt) !== null && _d !== void 0 ? _d : toolData === null || toolData === void 0 ? void 0 : toolData['language_specific_prompt']) !== null && _e !== void 0 ? _e : {});
                }
            }, label: react_1["default"].createElement(Label_1["default"], { info: "", text: "Tool behavior" }) }),
        toolData.mode !== 'handoff' && (react_1["default"].createElement(TextInputComponent, { isMultilineError: "", onChange: function (value) { return onToolChange('name', value); }, value: (_b = toolData === null || toolData === void 0 ? void 0 : toolData.name) !== null && _b !== void 0 ? _b : '', themed: true, placeholder: "Enter tool name", label: react_1["default"].createElement(Label_1["default"], { info: "", text: "Tool name" }), disabled: readOnly })),
        toolData.mode !== 'tool_call' && (react_1["default"].createElement(TextInputComponent, { isMultilineError: "", onChange: function (value) { return onToolChange('description', value); }, value: (_c = toolData === null || toolData === void 0 ? void 0 : toolData.description) !== null && _c !== void 0 ? _c : '', themed: true, placeholder: "Enter description", label: react_1["default"].createElement(Label_1["default"], { info: "", text: "Description" }), disabled: readOnly })),
        toolData.mode === 'tool_call' && (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(box_1["default"], { flexDirection: "column", padding: "0" },
                react_1["default"].createElement(text_1["default"], { variant: "body.md", style: { marginBottom: '6px' } }, "Tool code"),
                react_1["default"].createElement(button_1["default"], { themed: true, variant: readOnly ? 'disabled' : 'secondary', disabled: readOnly, onClick: function () {
                        if (hasUnsavedChanges && !isNewTool) {
                            BotActions_1.showConfirmationDialog({
                                title: 'Warning',
                                message: 'You have unsaved configuration changes that will be lost. ' +
                                    'Please save your changes before proceeding.',
                                okTitle: 'Proceed',
                                cancelTitle: 'Cancel',
                                onOk: function () {
                                    if (onDiscardChanges) {
                                        onDiscardChanges();
                                    }
                                    setOpenCodeEditor(true);
                                },
                                okActionType: 'danger',
                            });
                        }
                        else {
                            setOpenCodeEditor(true);
                        }
                    }, style: { width: 'max-content' } }, "Open Code Editor")),
            openCodeEditor && !readOnly && (react_1["default"].createElement(CodeEditor_1["default"], { id: toolData.id, navToMenu: function (edited) { return navToCodeSubMenu(edited); }, code: (toolData === null || toolData === void 0 ? void 0 : toolData.code) ||
                    (VoiceAgentLayoutUtils_1.getToolCallCodeType(toolData) === 'quick'
                        ? VoiceAgentLayoutUtils_1.QUICK_CODE_MULTI_VOICE_AGENT
                        : const_2.INIT_CODE_MULTI_VOICE_AGENT), envVariables: envVariables, inputJSON: JSON.stringify({ abc: '123' }, null, 2), onSave: function (code, cb) {
                    handleSave(code, cb);
                }, onRun: function (inputJSON, cb) {
                    handleRun(inputJSON, cb);
                }, envVariablesEnabled: _utils_1.userHasPermission(const_1.PERMISSION_LEVELS.EDIT_ENV_VARIABLES), headerHeight: 31, onSaveWithVariables: function (variables, code, cb) {
                    onSaveWithVariables(variables, code, cb);
                }, isVoiceAgent: [3, 4].includes(botSettings.domain_type) })),
            react_1["default"].createElement(TextInputComponent, { isMultilineError: "", onChange: function (value) { return onToolChange('description', value); }, value: (_d = toolData === null || toolData === void 0 ? void 0 : toolData.description) !== null && _d !== void 0 ? _d : '', themed: true, placeholder: "Enter description", label: react_1["default"].createElement(Label_1["default"], { info: "", text: "Description" }), disabled: readOnly }),
            react_1["default"].createElement(box_1["default"], { flexDirection: "column", padding: "0" },
                react_1["default"].createElement(text_1["default"], { variant: "body.md" }, "Parameters"),
                parameterRows.length > 0 && (react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column", style: { gap: '8px', marginTop: '6px' } }, parameterRows.map(function (parameterRow, rowIndex) { return (react_1["default"].createElement(box_1["default"], { key: parameterRow.rowId || "param-" + rowIndex, padding: "0", alignItems: "center", style: { gap: '12px' } },
                    react_1["default"].createElement(TextInputComponent, { themed: true, isMultilineError: "", value: parameterRow.name, placeholder: "name", disabled: readOnly, onChange: function (value) {
                            if (readOnly)
                                return;
                            var nextRows = __spreadArrays(parameterRows);
                            nextRows[rowIndex] = __assign(__assign({}, nextRows[rowIndex]), { name: value });
                            syncParameterRows(nextRows);
                        } }),
                    react_1["default"].createElement(dropdown_1["default"], { themed: true, placeholder: "type", options: VoiceAgentLayoutUtils_1.PARAMETER_TYPE_OPTIONS, value: VoiceAgentLayoutUtils_1.PARAMETER_TYPE_OPTIONS.find(function (option) { return option.id === parameterRow.type; }) || VoiceAgentLayoutUtils_1.PARAMETER_TYPE_OPTIONS[0], optionKey: "name", disabled: readOnly, onChange: function (value) {
                            if (readOnly)
                                return;
                            var nextRows = __spreadArrays(parameterRows);
                            nextRows[rowIndex] = __assign(__assign({}, nextRows[rowIndex]), { type: value === null || value === void 0 ? void 0 : value.id });
                            syncParameterRows(nextRows);
                        }, style: { width: '100px', marginTop: '-6px' } }),
                    react_1["default"].createElement(TextInputComponent, { themed: true, isMultilineError: "", value: parameterRow.description, placeholder: "description", disabled: readOnly, onChange: function (value) {
                            if (readOnly)
                                return;
                            var nextRows = __spreadArrays(parameterRows);
                            nextRows[rowIndex] = __assign(__assign({}, nextRows[rowIndex]), { description: value });
                            syncParameterRows(nextRows);
                        } }),
                    react_1["default"].createElement(TextInputComponent, { themed: true, isMultilineError: "", value: parameterRow.enumValues, placeholder: "enum values comma separated", disabled: readOnly, onChange: function (value) {
                            if (readOnly)
                                return;
                            var nextRows = __spreadArrays(parameterRows);
                            nextRows[rowIndex] = __assign(__assign({}, nextRows[rowIndex]), { enumValues: value });
                            syncParameterRows(nextRows);
                        } }),
                    react_1["default"].createElement(box_1["default"], { padding: "0", alignItems: "center" },
                        react_1["default"].createElement(checkbox_1["default"].Item, { value: Boolean(parameterRow.required), label: "Required", themed: true, disabled: readOnly, onChange: function (checked) {
                                if (readOnly)
                                    return;
                                var nextRows = __spreadArrays(parameterRows);
                                nextRows[rowIndex] = __assign(__assign({}, nextRows[rowIndex]), { required: checked });
                                syncParameterRows(nextRows);
                            } })),
                    react_1["default"].createElement(box_1["default"], { padding: "0", style: {
                            cursor: readOnly ? 'not-allowed' : 'pointer',
                            opacity: readOnly ? 0.45 : 1,
                        }, onClick: function () {
                            if (readOnly)
                                return;
                            BotActions_1.showConfirmationDialog({
                                okTitle: 'Delete',
                                cancelTitle: 'Cancel',
                                title: 'Delete this parameter?',
                                message: 'This action cannot be undone.',
                                okActionType: 'danger',
                                onCancel: function () { },
                                onOk: function () {
                                    var nextRows = __spreadArrays(parameterRows);
                                    nextRows.splice(rowIndex, 1);
                                    syncParameterRows(nextRows);
                                },
                            });
                        }, title: "Remove parameter" },
                        react_1["default"].createElement(BinIcon_1["default"], { size: "small", iconColor: "red.haptik" })))); })))),
            react_1["default"].createElement(button_1["default"], { themed: true, variant: readOnly ? 'disabled' : 'secondary', disabled: readOnly, onClick: function () {
                    var nextRows = __spreadArrays(parameterRows, [
                        {
                            rowId: "param-new-" + Date.now() + "-" + Math.floor(Math.random() * 1000),
                            name: '',
                            type: 'string',
                            description: '',
                            enumValues: '',
                            required: false,
                        },
                    ]);
                    syncParameterRows(nextRows);
                }, style: { width: 'max-content' } }, "Add Parameter"))),
        toolData.mode === 'rag' && (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(TextInputComponent, { onChange: function (value) { return onToolChange('appId', value); }, value: (_e = toolData === null || toolData === void 0 ? void 0 : toolData.appId) !== null && _e !== void 0 ? _e : '', themed: true, placeholder: "Vertex app id", label: react_1["default"].createElement(Label_1["default"], { info: "", text: "RAG App ID" }), disabled: readOnly }),
            react_1["default"].createElement(TextInputComponent, { themed: true, multiline: true, autoExpand: true, maxHeight: 400, onChange: function (value) { return onToolChange('prompt', value); }, value: (_f = toolData === null || toolData === void 0 ? void 0 : toolData.prompt) !== null && _f !== void 0 ? _f : '', placeholder: "Instructions for how the RAG answer should be phrased.", label: react_1["default"].createElement(Label_1["default"], { info: "", text: "RAG Prompt" }), disabled: readOnly }),
            react_1["default"].createElement(box_1["default"], { padding: "0", style: { gap: '12px' }, alignItems: "flex-start" },
                react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column", style: { minWidth: '280px' } },
                    react_1["default"].createElement(dropdown_1["default"], { themed: true, placeholder: "Select language", options: languagesList, value: activeRagLanguage, optionKey: "name", onChange: function (val) {
                            if (readOnly)
                                return;
                            setSelectedRagLanguage(val);
                        }, label: react_1["default"].createElement(Label_1["default"], { info: "", text: "Language" }), disabled: readOnly }),
                    react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "grey.dark", style: { marginTop: '8px' } },
                        configuredLanguageCount,
                        " languages configured")),
                react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column", style: { flex: 1, minWidth: 0 } },
                    react_1["default"].createElement(TextInputComponent, { themed: true, multiline: true, autoExpand: true, maxHeight: 300, isMultilineError: "", placeholder: "Add RAG prompt instruction for the selected language", value: (_g = languageSpecificPrompt[(activeRagLanguage === null || activeRagLanguage === void 0 ? void 0 : activeRagLanguage.code) || (activeRagLanguage === null || activeRagLanguage === void 0 ? void 0 : activeRagLanguage.id)]) !== null && _g !== void 0 ? _g : '', onChange: function (value) {
                            var _a;
                            return readOnly
                                ? undefined
                                : onToolChange('languageSpecificPrompt', __assign(__assign({}, languageSpecificPrompt), (_a = {}, _a[(activeRagLanguage === null || activeRagLanguage === void 0 ? void 0 : activeRagLanguage.code) || (activeRagLanguage === null || activeRagLanguage === void 0 ? void 0 : activeRagLanguage.id)] = value, _a)));
                        }, label: react_1["default"].createElement(Label_1["default"], { info: "", text: "Language-Specific Prompt" }), disabled: readOnly ||
                            (!(activeRagLanguage === null || activeRagLanguage === void 0 ? void 0 : activeRagLanguage.code) && !(activeRagLanguage === null || activeRagLanguage === void 0 ? void 0 : activeRagLanguage.id)) }),
                    react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "grey.dark", style: { marginTop: '8px' } }, "Stored as a language-code to prompt map for this tool."))))),
        toolData.mode === 'handoff' && (react_1["default"].createElement(dropdown_1["default"], { placeholder: "Select next agent", themed: true, options: nextAgentOptions, value: selectedNextAgent, optionKey: "name", disabled: readOnly, onChange: function (val) {
                if (readOnly)
                    return;
                onToolChange('nextAgent', val === null || val === void 0 ? void 0 : val.name);
                var nextAgentName = VoiceAgentLayoutUtils_1.toSnakeCase((val === null || val === void 0 ? void 0 : val.name) || '');
                onToolChange('name', nextAgentName ? "route_to_" + nextAgentName : '');
            }, label: react_1["default"].createElement(Label_1["default"], { info: "", text: "Next agent" }) })),
        toolData.mode === 'handoff' && (react_1["default"].createElement(TextInputComponent, { isMultilineError: "", onChange: function (value) { return onToolChange('name', value); }, value: (_h = toolData === null || toolData === void 0 ? void 0 : toolData.name) !== null && _h !== void 0 ? _h : '', themed: true, placeholder: "Enter tool name", label: react_1["default"].createElement(Label_1["default"], { info: "", text: "Tool name(auto)" }), disabled: readOnly })),
        react_1["default"].createElement(box_1["default"], { alignItems: "center", style: { gap: '8px' } },
            react_1["default"].createElement(Label_1["default"], { text: "Send Acknowledgement Message", info: "Sends a brief acknowledgement while waiting for this tool to complete if the AI Agent doesn't generate one on its own. Helps avoid awkward silence. Ideal for tools that may take a few seconds to respond." }),
            react_1["default"].createElement(toggle_1["default"], { themed: true, value: Boolean(toolData === null || toolData === void 0 ? void 0 : toolData.requiresAck), onChange: function (checked) { return onToolChange('requiresAck', checked); }, disabled: readOnly, style: { width: 'max-content' } }))));
};
exports["default"] = VoiceAgentToolItem;
